import React from "react";
import { useQuery, useQueryClient } from "react-query";
import { ResourceNames } from "../../Utils/ResourceNames";
import { useSelector } from "react-redux";
import { RootState } from "../../BusinessObjects/Redux/app/store";
import cubeApiClient from "../../BusinessObjects/cubeApiService";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import RenderFormNew from "../../Components/Esaedro/RenderForm/RenderFormNew";
import {
  createEmptyObjectFromFormField,
  createEmptyObjectFromResourceField,
  getFormFields,
} from "../../Utils/EsaedroHelper";
import { Form } from "../../Models/SysConf/Form";
import DelayedDataGrid2 from "../../Components/Esaedro/DelayedDataGrid/DelayedDataGrid2";
import { CustomColumn } from "../../Models/Project/CustomColumn";
import EsaedroLookupItem from "../../Models/EsaedroLookupItem";
import { CheckBox, NumberBox, SelectBox } from "devextreme-react";
import { LoadingButton } from "@mui/lab";
import notify from "devextreme/ui/notify";
import { Tab, Tabs } from "react-bootstrap";
import UserProfile from "../../Models/UserProfile";
import { useNavigate } from "react-router-dom";
import { RoutePath } from "../../Utils/RoutePath";
import { FormField } from "../../Models/SysConf/FormField";
import ResourceField from "../../Models/ResourceField";

const clone = require("clone");

type Props = {};

const CreateUserPage = (props: Props) => {
  const savedResourceViewObject = React.useRef<boolean>(false);

  const tokenApi = useSelector((state: RootState) => state.user.tokenAPI);
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);

  const newAsnNetUserId = React.useRef<string | undefined>(undefined);
  const [aspNetUserObject, setAspNetUserObject] =
    React.useState<any>(undefined);
  const [selectedPackCode, setSelectedPackCode] = React.useState<
    string | undefined
  >(undefined);
  const [easySellPackCode, setEasySellPackCode] =
    React.useState<boolean>(false);
  const [selectedSerialNumber, setSelectedSerialNumber] = React.useState<
    string | undefined
  >(undefined);
  const [selectedAgente, setSelectedAgente] = React.useState<
    string | undefined
  >(undefined);
  const [createEasySellResourceView, setCreateEasySellResourceView] =
    React.useState<boolean>(false);
  const [protectionLevel, setProtectionLevel] = React.useState<number>(0);

  const [newUserCreated, setNewUserCreated] = React.useState<boolean>(false);
  const [loadingNewUser, setLoadingNewUser] = React.useState<boolean>(false);

  const [updatedUserProfile, setUpdatedUserProfile] =
    React.useState<boolean>(false);
  const [loadingUpdateUserProfile, setLoadingUpdateUserProfile] =
    React.useState<boolean>(false);

  const [resourceViewObject, setResourceViewObject] =
    React.useState<any>(undefined);
  const [teveParametriPiazzistaObject, setTeveParametriPiazzistaObject] =
    React.useState<any>(undefined);
  const [automezziAziendaliObject, setAutomezziAziendaliObject] =
    React.useState<any>(undefined);

  const [
    loadingNewTeVeParametriPiazzista,
    setLoadingNewTeVeParametriPiazzista,
  ] = React.useState<boolean>(false);
  const [
    newTeVeParametriPiazzistaCreated,
    setNewTeVeParametriPiazzistaCreated,
  ] = React.useState<boolean>(false);

  const [loadingNewAutomezziAziendali, setLoadingNewAutomezziAziendali] =
    React.useState<boolean>(false);
  const [newAutomezzoAziendaleCreated, setNewAutomezzoAziendaleCreated] =
    React.useState<boolean>(false);

  const [loadingNewResourceView, setLoadingNewResourceView] =
    React.useState<boolean>(false);
  const [newResourceViewCreated, setNewResourceViewCreated] =
    React.useState<boolean>(false);

  const [formToShow, setFormToShow] = React.useState<number>(0);

  let navigate = useNavigate();

  const queryClient = useQueryClient();

  const {
    data: formAspnetUsers,
    isLoading: isLoadingFormAspnetUsers,
    isError: isErrorFormAspnetUsers,
  } = useQuery(
    ["form", ResourceNames.AspNetUsers, userProfile?.customer_ID, tokenApi],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/${ResourceNames.Resources}?RecordSelection=ResourceName='${ResourceNames.AspNetUsers}'`,
          tokenApi
        )
        .then(
          (data: any) => {
            let urlForm = `api/sys/${ResourceNames.Forms}/query?ResourceId=${data[0].Resource_ID}`;

            return service.getItems(urlForm, tokenApi).then(
              (data: any) => {
                return data[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: formTeVeParametriPiazzista,
    isLoading: isLoadingFormTeVeParametriPiazzista,
    isError: isErrorFormTeVeParametriPiazzista,
  } = useQuery(
    [
      "form",
      ResourceNames.TeVeParametriPiazzista,
      userProfile?.customer_ID,
      tokenApi,
    ],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/${ResourceNames.Resources}?RecordSelection=ResourceName='${ResourceNames.TeVeParametriPiazzista}'`,
          tokenApi
        )
        .then(
          (data: any) => {
            let urlForm = `api/sys/${ResourceNames.Forms}/query?ResourceId=${data[0].Resource_ID}`;

            return service.getItems(urlForm, tokenApi).then(
              (data: any) => {
                return data[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: formAutomezziAziendali,
    isLoading: isLoadingFormAutomezziAziendali,
    isError: isErrorFormAutomezziAziendali,
  } = useQuery(
    [
      "form",
      ResourceNames.AutomezziAziendali,
      userProfile?.customer_ID,
      tokenApi,
    ],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/${ResourceNames.Resources}?RecordSelection=ResourceName='${ResourceNames.AutomezziAziendali}'`,
          tokenApi
        )
        .then(
          (data: any) => {
            let urlForm = `api/sys/${ResourceNames.Forms}/query?ResourceId=${data[0].Resource_ID}`;

            return service.getItems(urlForm, tokenApi).then(
              (data: any) => {
                return data[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: packCodes,
    isLoading: isLoadingPackCodes,
    isError: isErrorPackCodes,
  } = useQuery(
    ["packCodes", userProfile?.customer_ID, tokenApi],
    () => {
      const service = new cubeApiClient();

      return service.getAll(`api/sys/LicensePacks`, tokenApi).then(
        (data: any) => {
          return data;
        },
        (error: any) => {
          return undefined;
        }
      );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const { data: dataCompany } = useQuery(
    ["company", "customer_ID", userProfile?.customer_ID, tokenApi],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/Companies?RecordSelection=customer_ID=${userProfile?.customer_ID}`,
          tokenApi
        )
        .then(
          (data: any) => {
            return data;
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: licenseSerials,
    isLoading: isLoadingLicenseSerials,
    isError: isErrorLicenseSerials,
  } = useQuery(
    ["licenseSerials", userProfile?.customer_ID, tokenApi],
    () => {
      const service = new cubeApiClient();

      let url = "api/sys/LicenseSerials";

      return service.getAll(url, tokenApi).then(
        (data: any) => {
          return data;
        },
        (error: any) => {
          return undefined;
        }
      );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: agenti,
    isLoading: isLoadingAgenti,
    isError: isErrorAgenti,
  } = useQuery(
    ["agenti", userProfile?.customer_ID, tokenApi],
    () => {
      const service = new cubeApiClient();
      const urlToUse = `api/sys/${ResourceNames.Agenti}?RecordSelection=customer_ID=${userProfile?.customer_ID}`;

      return service.getItems(urlToUse, tokenApi);
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: userProfileByEmail,
    isLoading: isLoadingUserProfileByEmail,
    isError: isErrorUserProfileByEmail,
    refetch: refetchUserProfileByEmail,
    isRefetching: isRefetchingUserProfileByEmail,
    isFetching: isFetchingUserProfileByEmail,
  } = useQuery(
    ["userProfileByEmail", tokenApi],
    () => {
      //Funzione utilizzara per recuperare lo UserProfile dell'utente appena creato, partendo dall'email che è univoca per ogni utente
      const urlToUse =
        "api/sys/AspNetUsers?RecordSelection=Email='" +
        aspNetUserObject.Email +
        "'"; //Recupero lo UserId
      const service = new cubeApiClient();

      return service.getItems(urlToUse, tokenApi).then(
        (data: any) => {
          if (data && data.length > 0 && data[0].UserId) {
            newAsnNetUserId.current = data[0].UserId;

            const urlToUseUserProfile =
              "api/sys/UserProfile?RecordSelection=UserId='" +
              data[0].UserId +
              "'";
            return service.getItems(urlToUseUserProfile, tokenApi).then(
              (data2: any) => {
                return data2[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          } else {
            notify(
              "Errore nel recupero dello UserProfile: UserId non trovato",
              "error",
              2000
            );
            return undefined;
          }
        },
        (error: any) => {
          return undefined;
        }
      );
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: resourcesFieldsResourcesViewes,
    isLoading: isLoadingResourcesFieldsResourcesViewes,
    isError: isErrorResourcesFieldsResourcesViewes,
    refetch: refetchResourcesFieldsResourcesViewes,
    isRefetching: isRefetchingResourcesFieldsResourcesViewes,
  } = useQuery(
    ["resourceFields", "ResourcesViewes", tokenApi, userProfile?.customer_ID],
    () => {
      const service = new cubeApiClient();
      const reqFieldsurl =
        `api/sys/${ResourceNames.ResourcesFields}?RecordSelection=` +
        encodeURIComponent("ResourceName='ResourcesViewes'");

      return service.getItems(reqFieldsurl, tokenApi);
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: resourceTeVeParametriPiazzista,
    isLoading: isLoadingResourceTeVeParametriPiazzista,
    isError: isErrorResourceTeVeParametriPiazzista,
    refetch: refetchResourceTeVeParametriPiazzista,
  } = useQuery(
    ["resource", "TeVeParametriPiazzista", tokenApi],
    () => {
      const service = new cubeApiClient();
      let url =
        "api/sys/Resources?RecordSelection=ResourceName='TeVeParametriPiazzista'";
      return service.getItems(url, tokenApi);
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  React.useEffect(() => {
    if (!isLoggedIn) navigate(RoutePath.LOGIN);
  }, []);

  React.useEffect(() => {
    return () => {
      queryClient.removeQueries([
        "packCodes",
        userProfile?.customer_ID,
        tokenApi,
      ]);
      queryClient.removeQueries([
        "licenseSerials",
        userProfile?.customer_ID,
        tokenApi,
      ]);
      queryClient.removeQueries(["agenti", userProfile?.customer_ID, tokenApi]);
      queryClient.removeQueries(["userProfileByEmail", tokenApi]);
      queryClient.removeQueries([
        "resourcesFields",
        "ResourcesViewes",
        userProfile?.customer_ID,
        tokenApi,
      ]);
      queryClient.removeQueries([
        "resource",
        "TeVeParametriPiazzista",
        userProfile?.customer_ID,
        tokenApi,
      ]);
    };
  }, []);

  React.useEffect(() => {
    if (formAspnetUsers) {
      let allFields = getFormFields(formAspnetUsers);
      setAspNetUserObject(
        createEmptyObjectFromFormField(
          allFields,
          userProfile?.customer_ID || -1
        )
      );
    }
  }, [formAspnetUsers]);

  React.useEffect(() => {
    if (formAutomezziAziendali) {
      let allFields = getFormFields(formAutomezziAziendali);
      setAutomezziAziendaliObject(
        createEmptyObjectFromFormField(
          allFields,
          userProfile?.customer_ID || -1
        )
      );
    }
  }, [formAutomezziAziendali]);

  React.useEffect(() => {
    if (formTeVeParametriPiazzista) {
      let allFields = getFormFields(formTeVeParametriPiazzista);
      setTeveParametriPiazzistaObject(
        createEmptyObjectFromFormField(
          allFields,
          userProfile?.customer_ID || -1
        )
      );
    }
  }, [formTeVeParametriPiazzista]);

  React.useEffect(() => {
    if (userProfileByEmail) {
      if (easySellPackCode) {
        setFormToShow(1);
      } else {
        updateUserProfile(userProfileByEmail);
        setFormToShow(2);
      }
    }
  }, [userProfileByEmail]);

  React.useEffect(() => {
    if (resourcesFieldsResourcesViewes) {
      setResourceViewObject(
        createEmptyObjectFromResourceField(
          resourcesFieldsResourcesViewes,
          userProfile?.customer_ID || -1
        )
      );
      refetchResourceTeVeParametriPiazzista();
    }
  }, [resourcesFieldsResourcesViewes]);

  React.useEffect(() => {
    if (
      resourceTeVeParametriPiazzista &&
      resourceTeVeParametriPiazzista.length > 0 &&
      resourceViewObject &&
      !savedResourceViewObject.current
    ) {
      // Setto i valori di default
      let tmpObj = clone(resourceViewObject);
      tmpObj.ViewName = null;
      tmpObj.Resource_ID = resourceTeVeParametriPiazzista[0].Resource_ID; //Mette il Resource_ID di TeVeParametriPiazzista
      tmpObj.ViewDescription =
        "Modificare i suoi parametri ma non quelli degli altri";
      tmpObj.UserName = aspNetUserObject?.UserName;
      tmpObj.FlagDefault = true;

      let resourceFields = resourceTeVeParametriPiazzista[0].ResourcesFields;
      if (resourceFields && resourceFields.length > 0) {
        let field_id: number =
          resourceTeVeParametriPiazzista[0].ResourcesFields.find(
            (f: any) => f.FieldName === "AgenteID"
          ).ResourceField_ID || -1;
        if (field_id !== -1) {
          let resourcesViewesFilters: any[] = [];
          let tmpResourcesViewesFilters: any = {
            FieldName: "AgenteID",
            Operator: "equal",
            Resource_ID: resourceTeVeParametriPiazzista[0].Resource_ID, //Mette il Resource_ID di Agenti
            ResourceField_ID: field_id, //Metto il ResourceField_ID di AgenteID
            ResourceName: "TeVeParametriPiazzista",
            Value: selectedAgente,
            PreviousFilterOperator: "or",
          };

          resourcesViewesFilters.push(tmpResourcesViewesFilters);

          tmpObj.ResourcesViewsFilters = resourcesViewesFilters;

          console.log("tmpObj", tmpObj);

          setResourceViewObject(tmpObj);
        } else {
          notify("Errore nel recupero del campo AgenteID", "error", 2000);
          setResourceViewObject(undefined);
        }
      } else {
        notify(
          "Errore nel recupero dei campi di TeVeParametriPiazzista",
          "error",
          2000
        );
        setResourceViewObject(undefined);
      }

      savedResourceViewObject.current = true; // In modo che non venga eseguito più di una volta
    }
  }, [resourceTeVeParametriPiazzista, resourceViewObject]);

  const formToRenderAspNetUsers = React.useMemo(() => {
    if (formAspnetUsers) {
      // Devo nascondere i campi PackCode, SerialNumber, UserId
      let tmpForm: Form = clone(formAspnetUsers);
      tmpForm.FormsGroups.forEach((group) => {
        group.FormsFields = group.FormsFields.filter((field) => {
          return (
            field.FieldName !== "PackCode" &&
            field.FieldName !== "SerialNumber" &&
            field.FieldName !== "UserId"
          );
        });
      });

      return tmpForm;
    }

    return undefined;
  }, [formAspnetUsers]);

  const formToRenderTeVeParametriPiazzista = React.useMemo(() => {}, [
    formTeVeParametriPiazzista,
  ]);

  const formToRenderAutomezziAziendali = React.useMemo(() => {}, [
    formAutomezziAziendali,
  ]);

  const itemsToDisplayPackCodes: EsaedroLookupItem[] = React.useMemo(() => {
    if (packCodes) {
      let itd: EsaedroLookupItem[] = [];

      packCodes.forEach((p: any) => {
        let description = `${p.PackCode} | ${p.PackDescription}`;
        let tmpPack: EsaedroLookupItem = new EsaedroLookupItem(
          p.PackCode,
          description
        );

        itd.push(tmpPack);
      });

      return itd;
    }

    return [];
  }, [packCodes]);

  const customSerialNumbersToDisplay: any[] = React.useMemo(() => {
    var serials: any[] = [];

    if (licenseSerials) {
      licenseSerials.forEach((s: any) => {
        let tmpSerial: any = s;
        let icon: string = "check";

        //TODO -> Gestire la data di scadenza
        if (s.NumerOfUsers <= s.LicensedUsersCount) {
          icon = "close";
        }
        tmpSerial.icon = icon;
        tmpSerial.SerialNumberToShow =
          s.SerialNumber + " - " + s.CustomerDescription;

        serials.push(tmpSerial);
      });
    }

    if (selectedPackCode) {
      let filtered = serials.filter(
        (snObj: any) => snObj.PackCode === selectedPackCode
      );

      serials = filtered;
    }

    if (dataCompany?.[0]?.VATCode) {
      // Filtro anche per VatCode
      let filtered = serials.filter(
        (snObj: any) => snObj.VatCode === dataCompany[0].VATCode
      );

      serials = filtered;
    }

    return serials;
  }, [licenseSerials, selectedPackCode, dataCompany]);

  const packCodeChangeHandler = (e: any) => {
    let packCode = "";
    if (e.selectedRowKeys) packCode = e.selectedRowKeys[0].PackCode;

    setSelectedPackCode(packCode);

    // Reset del numero seriale all'eliminazione del PackCode
    setSelectedSerialNumber(undefined);

    // Reset dell'agente e della lista agenti all'eliminazione del PackCode
    // setAgenti([]);
    setSelectedAgente(undefined);
    setCreateEasySellResourceView(false);

    setAspNetUserObject((prev: any) => {
      const tmpObj = Object.assign({}, prev);
      tmpObj.PackCode = packCode;
      tmpObj.SerialNumber = undefined;
      return tmpObj;
    });

    const pack = itemsToDisplayPackCodes.find(
      (el: any) => el.value === packCode
    );
    if (pack && pack.description.includes("Easy Sell")) {
      setEasySellPackCode(true);
    } else {
      setEasySellPackCode(false);
    }
  };

  const serialNumberChangeHandler = (value: any) => {
    setSelectedSerialNumber(value);

    setAspNetUserObject((prev: any) => {
      const tmpObj = Object.assign({}, prev);
      tmpObj.SerialNumber = value;
      return tmpObj;
    });
  };

  const checkNewUserObj = () => {
    let canCreate: boolean = true;

    //Fare le verifiche
    if (easySellPackCode) {
      if (selectedAgente !== "") {
        for (const key in aspNetUserObject) {
          if (key !== "UserId") {
            if (
              !(
                key === "ts_update" ||
                key === "ts_create" ||
                key === "flg_isdeleted" ||
                key === "dat_ultvar"
              )
            ) {
              if (
                aspNetUserObject[key] === "" ||
                aspNetUserObject[key] === undefined ||
                aspNetUserObject[key] === null
              ) {
                notify("Compilare tutti i campi - " + key, "error", 2000);
                canCreate = false;
              }
            }
          }
        }
      } else {
        notify("Compilare tutti i campi - Agente", "error", 2000);
        canCreate = false;
      }
    } else {
      for (const key in aspNetUserObject) {
        if (key !== "UserId") {
          if (
            !(
              key === "ts_update" ||
              key === "ts_create" ||
              key === "flg_isdeleted" ||
              key === "dat_ultvar"
            )
          ) {
            if (
              aspNetUserObject[key] === "" ||
              aspNetUserObject[key] === undefined ||
              aspNetUserObject[key] === null
            ) {
              notify("Compilare tutti i campi - " + key, "error", 2000);
              canCreate = false;
            }
          }
        }
      }
    }

    //Verifica Seriale
    if (canCreate) {
      let selectedSerial: any = customSerialNumbersToDisplay.find(
        (s: any) => s.SerialNumber === selectedSerialNumber
      );

      if (selectedSerial.NumerOfUsers <= selectedSerial.LicensedUsersCount) {
        notify("Non puoi creare un utente per questa licenza", "warning", 2000);
        canCreate = false;
      }
    }

    //Verifica Email
    if (canCreate) {
      if (!aspNetUserObject.Email.includes("@")) {
        notify("Email non valida", "error", 2000);
        canCreate = false;
      }
    }

    //Verifica Password

    //Verifica Password = ConfirmPassword
    if (canCreate) {
      if (aspNetUserObject.Password !== aspNetUserObject.ConfirmPassword) {
        notify("Le password non coincidono", "error", 2000);
        canCreate = false;
      }
    }

    return canCreate;
  };

  const saveAspNetUser = () => {
    //TODO: Faccio la chiamata all'endpoint /validate
    const service = new cubeApiClient();

    if (checkNewUserObj()) {
      setLoadingNewUser(true);
      service
        .updateObject(
          aspNetUserObject,
          `api/sys/${ResourceNames.AspNetUsers}`,
          tokenApi
        )
        .then(
          (data: any) => {
            /* Se la checkBox "Crea filtri EasySell per utente" ricavo i fields di ResourcesViewes */
            if (easySellPackCode && createEasySellResourceView) {
              refetchResourcesFieldsResourcesViewes();
            }

            refetchUserProfileByEmail();

            setLoadingNewUser(false);
            setNewUserCreated(true);
          },
          (error: any) => {
            setLoadingNewUser(false);
            setNewUserCreated(false);
            setFormToShow(0);
          }
        );
    }
  };

  const saveTeVeParametriPiazzista = () => {
    setLoadingNewTeVeParametriPiazzista(true);

    const service = new cubeApiClient();

    let objPushParametriPiazzista = teveParametriPiazzistaObject;

    service
      .updateObject(
        objPushParametriPiazzista,
        "api/Resources/TeVeParametriPiazzista",
        tokenApi
      )
      .then(
        (data: any) => {
          //notify("Parametri Piazzista creato", "success", 2000);

          setLoadingNewTeVeParametriPiazzista(false);
          setNewTeVeParametriPiazzistaCreated(true);
        },
        (error: any) => {
          setLoadingNewTeVeParametriPiazzista(false);
          setNewTeVeParametriPiazzistaCreated(false);
        }
      );
  };

  const saveAutomezzoAziendale = () => {
    setLoadingNewAutomezziAziendali(true);

    const service = new cubeApiClient();

    let objPushAutomezzo: any = automezziAziendaliObject;

    service
      .updateObject(
        objPushAutomezzo,
        "api/Resources/AutomezziAziendali",
        tokenApi
      )
      .then(
        (data: any) => {
          notify("Automezzo Aziendale creato", "success", 2000);

          setLoadingNewAutomezziAziendali(false);
          setNewAutomezzoAziendaleCreated(true);
        },
        (error: any) => {
          setLoadingNewAutomezziAziendali(false);
          setNewAutomezzoAziendaleCreated(false);
        }
      );
  };

  const saveResourceView = () => {
    setLoadingNewResourceView(true);

    const service = new cubeApiClient();

    let tmpResourcesViewes = resourceViewObject;

    //Setto il valore del filtro come il valore del parametro piazzista inserito (cod_piazzista = objPushParametriPiazzista.AgenteID)
    //Cambio il valore dell'filtro sull'agente_id
    tmpResourcesViewes.ResourcesViewsFilters[0].Value =
      teveParametriPiazzistaObject?.AgenteID;

    tmpResourcesViewes.UserId = newAsnNetUserId.current;

    service
      .updateObject(tmpResourcesViewes, "api/sys/ResourcesViewes", tokenApi)
      .then(
        (data: any) => {
          notify("Filtro su AgenteID creato", "success", 2000);

          setLoadingNewResourceView(false);
          setNewResourceViewCreated(true);
        },
        (error: any) => {
          notify("Filtro su AgenteID non creato", "error", 2000);

          setLoadingNewResourceView(false);
          setNewResourceViewCreated(false);
        }
      );
  };

  const saveEasySellObjects = () => {
    let canCreate: boolean = true;

    //Verifiche se i campi obbligatori sono stati inseriti

    if (
      automezziAziendaliObject.cod_automezzo ||
      automezziAziendaliObject.des_automezzo ||
      automezziAziendaliObject.des_targa
    ) {
      let fields = getFormFields(formAutomezziAziendali);
      fields.forEach((field: FormField) => {
        const verify = verifyField(field, automezziAziendaliObject);

        if (verify) {
          //Se è true vuol dire che il campo è obbligatorio ed è vuoto
          notify(
            "Inserire tutti i campi obbligatori - Automezzi(" +
              field.Field_Label +
              ")",
            "error",
            2000
          );
          canCreate = false;
        }
      });
    }

    let teVeFields = getFormFields(formTeVeParametriPiazzista);

    teVeFields.forEach((field: FormField) => {
      const verify = verifyField(field, teveParametriPiazzistaObject);

      if (verify) {
        //Se è true vuol dire che il campo è obbligatorio ed è vuoto
        notify(
          "Inserire tutti i campi obbligatori - Parametri Piazzista(" +
            field.Field_Label +
            ")",
          "error",
          2000
        );
        canCreate = false;
      }
    });

    if (canCreate && userProfileByEmail) {
      //Allo UserProfile setto l'Id dell'agente (AgenteId)
      let tmpUserProfile: UserProfile = userProfileByEmail;
      tmpUserProfile.AgenteID = selectedAgente ? selectedAgente : "";

      updateUserProfile(tmpUserProfile);
      saveTeVeParametriPiazzista();

      if (
        automezziAziendaliObject.cod_automezzo ||
        automezziAziendaliObject.des_automezzo ||
        automezziAziendaliObject.des_targa
      ) {
        saveAutomezzoAziendale();
      }

      if (createEasySellResourceView && resourceViewObject) {
        saveResourceView();
      }

      setFormToShow(2);
    }
  };

  const updateUserProfile = (userP: UserProfile) => {
    const service = new cubeApiClient();

    let objPush: UserProfile = userP;

    if (userP === undefined) {
      setFormToShow(0);
      setUpdatedUserProfile(false);
      notify("userProfile is undefined", "error", 2000);
    }

    objPush.ProtectionLevel = protectionLevel;

    setLoadingUpdateUserProfile(true);

    service.updateObject(objPush, "api/sys/UserProfile", tokenApi).then(
      (data: any) => {
        setLoadingUpdateUserProfile(false);
        setUpdatedUserProfile(true);

        notify("Utente creato", "success", 2000);

        // navigate(RoutePath.HOME)
      },
      (error: any) => {
        setLoadingUpdateUserProfile(false);
        setFormToShow(0);
        setUpdatedUserProfile(false);
      }
    );
  };

  const verifyField = (field: ResourceField | FormField, obj: any) => {
    // Questi campi non devono essere verificati
    if (
      field.FieldName !== "dat_obsoleto" &&
      field.FieldName !== "cod_utente_cre" &&
      field.FieldName !== "dat_utente_cre" &&
      field.FieldName !== "cod_utente_mod" &&
      field.FieldName !== "dat_utente_mod" &&
      field.FieldName !== "customer_ID" &&
      field.FieldName !== "SerialNumber" &&
      field.FieldName !== "UserId" &&
      field.FieldName !== "ts_update" &&
      field.FieldName !== "ts_create" &&
      field.FieldName !== "flg_isdeleted" &&
      field.FieldName !== "dat_ultvar" &&
      field.FieldName !== "Id"
    ) {
      if (field.Is_Key || !field.Is_Nullable) {
        if (
          obj[field.FieldName] === "" ||
          obj[field.FieldName] === undefined ||
          obj[field.FieldName] === null
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const columns: CustomColumn[] = [
    {
      dataField: "PackCode",
      caption: "PackCode",
    },
    {
      dataField: "PackDescription",
      caption: "PackDescription",
    },
  ];

  // Prima parte
  if (formToShow === 0) {
    if (
      isLoadingFormAspnetUsers ||
      isLoadingPackCodes ||
      isLoadingLicenseSerials
    ) {
      return (
        <Box sx={{ width: "100%", height: "100%" }}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        </Box>
      );
    }

    if (isErrorFormAspnetUsers || isErrorPackCodes || isErrorLicenseSerials) {
      return (
        <Box sx={{ width: "100%", height: "100%" }}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" component="div" gutterBottom>
              Errore nel caricamento della pagina
            </Typography>
          </Box>
        </Box>
      );
    }

    if (loadingNewUser || isLoadingUserProfileByEmail) {
      return (
        <Box sx={{ width: "100%", height: "100%" }}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        </Box>
      );
    }

    return (
      <Container maxWidth="lg" sx={{ mt: 5 }}>
        <Box sx={{ width: "100%", height: "100%" }}>
          <RenderFormNew
            showTitle={true}
            form={formToRenderAspNetUsers}
            isNew={true}
            myObj={aspNetUserObject}
            saveNewObject={(e) => {
              setAspNetUserObject(e);
            }}
          />

          <Divider sx={{ mt: 5 }} />

          <Grid container spacing={2} sx={{ mt: 5 }}>
            <Grid item xs={12} md={12}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography variant="body1">Pack Code</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <DelayedDataGrid2
                      gridColumns={columns}
                      gridValue={selectedPackCode}
                      itemsToDisplay={itemsToDisplayPackCodes}
                      dataGridObjects={packCodes}
                      fieldName="PackCode"
                      valueColumnName={"PackCode"}
                      handleChange={packCodeChangeHandler}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} md={12}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography variant="body1">Serial Number</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <SelectBox
                      value={selectedSerialNumber}
                      dataSource={
                        selectedPackCode ? customSerialNumbersToDisplay : []
                      }
                      displayExpr={"SerialNumberToShow"}
                      valueExpr={"SerialNumber"}
                      onValueChange={serialNumberChangeHandler}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} md={12}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography variant="body1">Protection Level</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <NumberBox
                      min={0}
                      max={99}
                      showSpinButtons={true}
                      showClearButton={true}
                      onValueChange={(e) => {
                        setProtectionLevel(e);
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            {easySellPackCode ? (
              <Grid item xs={12} md={12}>
                <Box sx={{ width: "100%", height: "100%" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <Typography variant="body1">Agente</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <SelectBox
                        dataSource={agenti}
                        displayExpr={"des_agente"}
                        valueExpr={"cod_agente"}
                        onValueChange={(e) => {
                          setSelectedAgente(e);
                        }}
                        value={selectedAgente}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            ) : null}
            {easySellPackCode ? (
              <Grid item xs={12} md={12}>
                <Box sx={{ width: "100%", height: "100%" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <Typography variant="body1">
                        Crea filtri EasySell
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <CheckBox
                        value={createEasySellResourceView}
                        onValueChange={(e) => {
                          setCreateEasySellResourceView(e);
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            ) : null}
          </Grid>

          <LoadingButton
            variant="contained"
            sx={{
              mt: 3,
              mb: 2,
              width: "100%",
            }}
            onClick={() => {
              if (easySellPackCode) {
                saveAspNetUser();
              } else {
                saveAspNetUser();
              }
            }}
            loading={loadingNewUser || isLoadingUserProfileByEmail}
          >
            {easySellPackCode ? "Avanti" : "Crea utente"}
          </LoadingButton>
        </Box>
      </Container>
    );
  }

  if (formToShow === 1) {
    // Per EasySell
    return (
      <Container maxWidth="lg" sx={{ mt: 5 }}>
        <Box sx={{ width: "100%", height: "100%" }}>
          <Typography variant="h5" component="div" gutterBottom>
            Filtro:{" "}
            {createEasySellResourceView
              ? resourceViewObject
                ? "Il filtro verrà salvato"
                : "Errore: il filtro non è stato salvato"
              : "Nessun filtro creato"}
          </Typography>
          <Typography variant="h5" component="div" gutterBottom>
            UserProfile:{" "}
            {userProfileByEmail
              ? "UserProfile recuperato"
              : "Errore: UserProfile non recuperato"}
          </Typography>

          <Button
            variant="contained"
            sx={{
              mt: 3,
              mb: 2,
              width: "100%",
            }}
            onClick={() => {
              saveEasySellObjects();
            }}
          >
            Salva
          </Button>

          <Divider sx={{ mt: 5, mb: 5 }} />

          <Tabs defaultActiveKey="piazzista" id="uncontrolled-tab-example">
            <Tab eventKey="piazzista" title="Piazzista">
              {isLoadingFormTeVeParametriPiazzista ? (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <Box sx={{ width: "100%", height: "100%", mt: 2 }}>
                  <RenderFormNew
                    showTitle={false}
                    isCustom={false}
                    isNew={true}
                    form={formTeVeParametriPiazzista}
                    myObj={teveParametriPiazzistaObject}
                    saveNewObject={(newObj: any) => {
                      setTeveParametriPiazzistaObject(newObj);
                    }}
                  />
                </Box>
              )}
            </Tab>
            <Tab eventKey="automezzo" title="Automezzo">
              {isLoadingFormAutomezziAziendali ? (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <Box sx={{ width: "100%", height: "100%", mt: 2 }}>
                  <RenderFormNew
                    showTitle={false}
                    isCustom={false}
                    isNew={true}
                    form={formAutomezziAziendali}
                    myObj={automezziAziendaliObject}
                    saveNewObject={(newObj: any) => {
                      setAutomezziAziendaliObject(newObj);
                    }}
                  />
                </Box>
              )}
            </Tab>
          </Tabs>
        </Box>
      </Container>
    );
  }

  if (formToShow === 2) {
    if (loadingUpdateUserProfile) {
      return (
        <Box sx={{ width: "100%", height: "100%" }}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        </Box>
      );
    }

    if (easySellPackCode) {
      if (
        loadingNewAutomezziAziendali ||
        loadingNewTeVeParametriPiazzista ||
        loadingNewResourceView
      ) {
        return (
          <Box sx={{ width: "100%", height: "100%" }}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </Box>
          </Box>
        );
      }
    }

    // Riepilogo
    return (
      <Container maxWidth="lg" sx={{ mt: 5 }}>
        <Typography variant="h5" component="div" gutterBottom>
          Riepilogo
        </Typography>
        <Box sx={{ width: "100%", height: "100%" }}>
          <Typography variant="body1" component="div" gutterBottom>
            Utente creato con successo
          </Typography>
        </Box>
      </Container>
    );
  }

  return null;
};

export default CreateUserPage;
